module.exports = __webpack_public_path__ + "static/media/chart-line.a546b1ae.svg";